import { TokenService } from './token.service';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
    private router: Router,
    private token: TokenService
  ) { }

  public canActivate(): boolean {
    if (this.token.isLoggedIn()) {
      return true;
    } else {
      this.token.removeToken();
      this.router.navigate(['/login']);
      return false;
    }
  }

}
